/**
 * Resource that represents a Device Controller (used to control printers, etc.).
 *
 * @name DeviceController
 * @class
 * @augments TmrResource
 */
function DeviceControllerFactory(TmrApi, TmrResource) {
  'ngInject'
  /**
   * Loads the API Key of the Device Controller
   *
   * @method DeviceController#$apiKey
   */
  function $apiKey() {
    return TmrApi.get(
      'DeviceController.apiKey',
      { id: this.id },
      { transformResponse: [] }
    ).then(res => res.data)
  }

  let DeviceController = TmrResource('DeviceController')

  Object.assign(DeviceController.prototype, { $apiKey })

  return DeviceController
}

export const factory = ['DeviceController', DeviceControllerFactory]
